import { ShippingApi } from "@/api/shipping.api";

export default async function dashboardShippingsLoader() {
  const [shippings] = await Promise.all([ShippingApi.getOrders()]);

  return {
    shippings: shippings.orders.sort((a, b) =>
      a.ordered_at > b.ordered_at ? -1 : 1
    ),
  };
}
